<div class="column serving">
    <div class="cell">
        @if (vm().currentlyServing === 1) {
            <span class="serving-dot"></span>
        }
    </div>
    <div class="cell">
        @if (vm().currentlyServing === 2) {
            <span class="serving-dot"></span>
        }
    </div>
</div>
<div class="column divider">
    <div class="cell">{{ vm().player1CurrentScore }}</div>
    <div class="cell">{{ vm().player2CurrentScore }}</div>
</div>

@if (vm().participant1 || vm().participant2) {
    <div class="column sets">
        <div class="cell">{{ vm().participant1 }}</div>
        <div class="cell">{{ vm().participant2 }}</div>
    </div>
}
